<template>
    <div class="spinner" v-if="loading">
        <div class="preload_spinner">
            <div class="preload_spinner_inside">
                <div></div>
            </div>
        </div>
    </div>
    <div class="map-edit" id="map-edit" v-else>
        <div class="map">
            <img class="image" :src="map.picture" />
            <label for="picture" ref="preview" class="file" data-value="true"
                >Picture</label
            >
            <input
                type="file"
                id="picture"
                @change="
                    (e) => {
                        if (e.target.files[0]) setPreview(e.target.files[0]);
                        checkValid(() => {}, true, false, false);
                    }
                "
                accept="image/png"
                required
            />
            <label for="name">Name</label>
            <input
                type="text"
                ref="name"
                required
                minlength="5"
                maxlength="40"
                :value="map.name"
                @keyup="
                    (e) => {
                        map.name = e.target.value;
                        checkValid(() => {}, false, true);
                    }
                "
            />
            <label for="description">Description</label>
            <input
                type="text"
                ref="description"
                required
                minlength="10"
                maxlength="255"
                :value="map.description"
                @keyup="
                    (e) => {
                        map.description = e.target.value;
                        checkValid(() => {}, false, false, true);
                    }
                "
            />
            <div class="versions" id="versions">
                <label>Versions</label>
                <div
                    class="version"
                    v-for="version in map.versions"
                    :key="version.name + Math.random()"
                >
                    <input
                        class="version-name"
                        type="text"
                        :value="version.name"
                        :ref="`version-name-${version.name}`"
                        @change="
                            (e) => {
                                const newName = e.target.value;
                                if (map.currentVersion === version.name)
                                    map.currentVersion = newName;
                                version.name = newName;
                                checkValidVersions();
                            }
                        "
                    />
                    <label
                        :for="`version-map-upload-${version.name}`"
                        :ref="`version-map-upload-${version.name}-label`"
                        class="button-green file version-map"
                    >
                        Update Map
                    </label>
                    <input
                        type="file"
                        :id="`version-map-upload-${version.name}`"
                        @change="
                            (e) => {
                                (async function read() {
                                    if (e.target.files[0])
                                        version.map = await readFileJSON(
                                            e.target.files[0]
                                        );
                                    checkValidVersions();
                                })();
                            }
                        "
                        accept="application/JSON"
                        class="version-map-file"
                        required
                    />
                    <button
                        class="version-remove button-red"
                        @dblclick="
                            (e) =>
                                (map.versions = map.versions.filter(
                                    (x) => x.name !== version.name
                                ))
                        "
                    >
                        Remove
                    </button>
                </div>
                <button class="add button-green" @click="addVersion()">
                    Add
                </button>
            </div>
            <div class="current-version">
                <label for="currentVersion">Current Version</label>
                <select
                    id="currentVersion"
                    @change="(e) => (map.currentVersion = e.target.value)"
                >
                    <option
                        v-for="version in map.versions"
                        :key="version.name + Math.random()"
                        :selected="map.currentVersion === version.name"
                        :value="version.name"
                        >{{ version.name }}
                    </option>
                </select>
            </div>

            <button class="remove button-red" @click="remove(map._id)">
                Remove
            </button>
            <button
                class="save button-green"
                @click="
                    checkValid(
                        (valid) => (valid ? sendPost(map._id) : null),
                        true,
                        true,
                        true,
                        true
                    )
                "
            >
                Save
            </button>
        </div>
    </div>
</template>

<script>
import variables from "../../api/variables.json";
export default {
    name: "Edit",
    data() {
        return {
            loading: true,
            versionCount: 0,
            map: {
                _id: 0,
                picture: "",
                name: "",
                description: "",
                map: {},
                versions: [{ name: "default", map: null }],
                currentVersion: "default",
            },
        };
    },
    computed: {
        token() {
            return this.$store.getters.token;
        },
        id() {
            return this.$store.getters.userId;
        },
    },
    created() {
        this.getMap();
    },
    mounted() {},
    methods: {
        async getMap() {
            fetch(
                `${variables.host}/api/map?user=${this.id}&id=${this.$route.params.id}&picture=true`
            )
                .then((response) => {
                    if (response.status === 200) return response.json();
                })
                .then((maps) => {
                    if (!maps || !maps[0]) return this.$router.replace("./");
                    this.map = maps[0];
                    if (!this.map.versions || !this.map.versions.length > 0)
                        this.map.versions = [
                            { name: "default", map: this.map.map },
                        ];
                    if (!this.map.currentVersion)
                        this.map.currentVersion = "default";

                    this.loading = false;
                })
                .catch((err) => console.log(err));
        },
        remove(id) {
            fetch(`${variables.host}/api/map`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${this.token}`,
                },
                body: JSON.stringify({ id: id }),
            })
                .then((response) => {
                    if (response.status === 200) this.$router.replace("./");
                    if (response.status === 401) {
                        this.$store.commit("setAuthentication", {
                            token: null,
                            userId: null,
                        });
                        this.$router.push({ name: "login" });
                    }
                })
                .catch(() => {});
        },
        readURL(file) {
            return new Promise((resolve) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };

                reader.readAsDataURL(file);
            });
        },
        readFileJSON(file) {
            return new Promise((resolve) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    if (e.target.result) {
                        try {
                            resolve(JSON.parse(e.target.result));
                        } catch (error) {
                            resolve(null);
                        }
                    } else {
                        resolve(null);
                    }
                };

                reader.readAsText(file);
            });
        },
        setPreview(file) {
            this.readURL(file).then((src) => {
                this.map.picture = src;
            });
        },
        checkValid(
            callback,
            picture = false,
            name = false,
            description = false,
            versions = false
        ) {
            this.$nextTick(() => {
                let valid = true;
                if (name) {
                    if (this.$refs["name"].checkValidity())
                        this.$refs["name"].setAttribute("data-value", "true");
                    else {
                        this.$refs["name"].setAttribute("data-value", "false");
                        valid = false;
                    }
                }
                if (description) {
                    if (this.$refs["description"].checkValidity())
                        this.$refs["description"].setAttribute(
                            "data-value",
                            "true"
                        );
                    else {
                        this.$refs["description"].setAttribute(
                            "data-value",
                            "false"
                        );
                        valid = false;
                    }
                }
                if (picture) {
                    if (
                        !this.map.picture ||
                        !this.map.picture.startsWith("data:image/png")
                    ) {
                        valid = false;
                        this.$refs[`preview`].setAttribute("data-value", false);
                    } else
                        this.$refs[`preview`].setAttribute("data-value", true);
                }
                if (versions) {
                    this.checkValidVersions((newValid) =>
                        callback(!(!newValid || !valid))
                    );
                } else {
                    return valid;
                }
            });
        },

        checkValidVersions(callback = () => {}) {
            this.$nextTick(() => {
                let valid = true;
                for (let i = 0; i < this.map.versions.length; i++) {
                    const version = this.map.versions[i];
                    if (
                        !version.map ||
                        typeof version.map !== "object" ||
                        !version.map.ids ||
                        !version.map.entities
                    ) {
                        valid = false;
                        this.$refs[
                            `version-map-upload-${version.name}-label`
                        ][0].setAttribute("data-value", false);
                    } else {
                        this.$refs[
                            `version-map-upload-${version.name}-label`
                        ][0].setAttribute("data-value", true);
                    }

                    if (
                        version.name.length < 3 ||
                        version.name.length > 10 ||
                        this.map.versions.filter((x) => x.name === version.name)
                            .length > 1
                    ) {
                        valid = false;
                        this.$refs[
                            `version-name-${version.name}`
                        ][0].setAttribute("data-value", false);
                    } else {
                        this.$refs[
                            `version-name-${version.name}`
                        ][0].setAttribute("data-value", true);
                    }
                }
                return callback(valid);
            });
        },

        async sendPost() {
            const data = {
                id: this.map._id,
                picture: this.map.picture,
                name: this.map.name,
                description: this.map.description,
                versions: this.map.versions,
                currentVersion: this.map.currentVersion,
            };

            fetch(`${variables.host}/api/map`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${this.token}`,
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                    if (response.status === 200) {
                        window.location.reload();
                    } else {
                        if (response.status === 401) {
                            this.$store.commit("setAuthentication", {
                                token: null,
                                userId: null,
                            });
                            this.$router.push({ name: "login" });
                        }
                        this.checkValid(() => {}, true, true, true, true);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.checkValid(() => {}, true, true, true, true);
                });
        },

        addVersion() {
            const versionName =
                this.map.versions.length +
                "" +
                Math.floor(Math.random() * 11) +
                "" +
                Math.floor(Math.random() * 11);

            this.map.versions.push({
                name: versionName,
                map: null,
            });
        },
    },
};
</script>

<style scoped lang="scss" src="./assets/css/edit.scss"></style>
